<template>
  <div class="line">
    <div class="line__header">
      <div class="line__header-icon">
        <img :src="item.mainIcon" />
      </div>

      <div class="line__header-content">
        <p class="line__header-content__field">
          {{ item.field }}
        </p>
        <input v-model="item.value" disabled />
      </div>
    </div>

    <div class="line__footer">
      <img src="@/assets/icons/menu/edit.svg" @click="edicao()" />
      <img src="@/assets/icons/eye.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalLine',
  props: ['item'],
  methods: {
    edicao() {
      // console.log("Clicou na edicao")

      document.querySelector('input:disabled').removeAttribute('disabled');
    },
  },
};
</script>

<style scoped lang="scss">
.line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e4e7eb;
  padding: 20px 0;

  .line__header {
    display: flex;
    align-items: center;

    .line__header-icon {
      width: 60px;
      height: 60px;
      border: 1px solid #c7ced4;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      margin-right: 20px;
    }

    .line__header-content__field {
      font-weight: 700;
      font-size: 1rem;
      color: #66788a;
    }

    input {
      color: black;

      &:disabled {
        border: none;
        background: transparent;
        color: #9ea0a5;
      }
    }
  }

  .line__footer {
    img {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
</style>